module.exports = __webpack_public_path__ + "img/er5.97ee9218.png";